export default "__VITE_ASSET__0f447eb2__"